module.exports = __webpack_public_path__ + "static/img/Group223.24135d7a.png";